import {Injectable} from "@angular/core";
import {first, map} from "rxjs/operators";
import {List} from "immutable";
import {Observable, of} from "rxjs";
import {AuthenticationService} from "../../authentication/authentication.service";
import {EndpointsProvider} from "../../umbrella-common/endpoints/endpoint-provider.service";

@Injectable()
export class CertificateBodiesFetchService {

	constructor(private endpoints: EndpointsProvider, private authService: AuthenticationService) {
	}

	fetchCertificateBodies(): Observable<string[]> {
		let countryCode = this.authService.getClientCountry();
		if (countryCode === null || countryCode === 'undefined') {
			return of([]);
		}
		if (countryCode == 'CA') {
			countryCode = 'US';
		}

		return this.endpoints.assets.getCertificationBodiesFor(countryCode)
			.pipe(
				first(),
				map(value => List(value.split(','))),
				map(value => value.map(str => str.trim()).toArray())
			);
	}
}
